// extracted by mini-css-extract-plugin
export default {"container":"video_container__c5s86","videoContainer":"video_videoContainer__QVgud"};